module.exports = __webpack_public_path__ + "img/19.c988207a.jpg";